import { SynchTripImportDTO } from 'business/models/Models';
import React, { useContext, useEffect } from 'react';
import ImportSynchTripWizardContext from './importSynchTripWizardContext';
import SynchTripTable from './synchTripTable';

const MapDataPage = () => {
  const synchTripContext = useContext(ImportSynchTripWizardContext);

  useEffect(() => {
    synchTripContext.setNextButtonDisallowed(true);
    mapDataToDTO();
    synchTripContext.setNextButtonDisallowed(false);
  }, []);

  const mapDataToDTO = () => {
    const importList: SynchTripImportDTO[] = synchTripContext.fileContent.map((st) => {
      const importDTO = {
        crystalName: st[4],
        crystalId: st[3] === '' ? 0 : st[3],
        dewarId: st[7] === '' ? 0 : st[7],
        dewarName: st[8],
        puckPinPosition: st[6] === '' ? 0 : st[6],
        puckName: st[5],
        synchTripId: st[0] === '' ? 0 : st[0],
        synchTripName: st[1],
        dataCollectionDate: st[2] === '' ? null : new Date(st[2]),
      };

      return importDTO;
    });

    synchTripContext.setSynchTripImportDTOList(importList);
  };

  return (
    <div
      id="mapdatapage-wrapper"
      className="flex flex-column w-320 h-full overflow-scroll"
    >
      {synchTripContext.synchTripImportDTOList && (
        <SynchTripTable tableData={synchTripContext.synchTripImportDTOList} />
      )}
    </div>
  );
};

export default MapDataPage;
